module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Banner-Desktop-@2x.d5a3e05e.webp";